import { Button, CreateAlert, InputWraper, useForm } from 'modules';
import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';

import { InputPassword } from '../../../components';
import { translate } from '../../../languages';
import { UserService } from '../../../services';
import { AdminService } from '../../../services/admin';
import { withConfigWraper } from '../wraper';

export const ChangePassword: FC<any> = withConfigWraper(() => {
  const navigate = useNavigate();

  const { handleSubmit, getInputProps, isSubmitting } = useForm({
    structure: [
      {
        name: 'oldPassword',
        validate: Yup.string().required('Must be provided'),
      },
      {
        name: 'newPassword',
        validate: Yup.string().required('Must be provided'),
        // .min(8, "Password is too short - should be 8 characters minimum.")
        // .max(20, "Password is too long - only 20 characters maximum.")
        // .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]/,"Password must contain one uppercase letter, one lowercase letter, one number and one special case character"),
      },
      {
        name: 'confirmNewPassword',
        validate: Yup.string()
          .required('Must be provided')
          .test({
            message: 'Password confirmation does not match',
            test: function (value) {
              const password = this.resolve(Yup.ref('newPassword'));
              if (password && value && value !== password) return false;
              return true;
            },
          }),
        // .min(8, "Password is too short - should be 8 characters minimum.")
        // .max(20, "Password is too long - only 20 characters maximum.")
        // .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]/,"Password must contain one uppercase letter, one lowercase letter, one number and one special case character"),
      },
    ],
    onSubmit: async (values) => {
      const payload = {
        oldPassword: values?.oldPassword,
        newPassword: values?.confirmNewPassword,
      };
      AdminService.ChangePassword(payload)
        .then((res) => {
          CreateAlert({
            type: 'success',
            message: 'Your password has changed',
          });
          UserService.logout().finally(() => navigate('/authentication/login'));
        })
        .catch((err) => {
          CreateAlert({ type: 'danger', message: translate(err.message) });
        })
        .finally(() => {});
    },
  });

  return (
    <div className='container-fluid change-password'>
      <div className='row'>
        <div className='col-4 change-password__form__col'>
          <div className='change-password__form'>
            <div className='change-password__form__title'>CHANGE PASSWORD</div>
            <div className='change-password__form__input'>
              <div className='row'>
                <div className='col-12'>
                  <InputWraper
                    label={'Current password'}
                    // placeholder={translate('Enter current password')}
                    inputProps={getInputProps('oldPassword')}
                    component={InputPassword}
                  />
                </div>
                <div className='col-12'>
                  <InputWraper
                    label={'New password'}
                    // placeholder={translate("Enter new password")}
                    inputProps={getInputProps('newPassword')}
                    component={InputPassword}
                  />
                </div>
                <div className='col-12'>
                  <InputWraper
                    label={'Confirm password'}
                    // placeholder={translate('Enter confirm password')}
                    inputProps={getInputProps('confirmNewPassword')}
                    component={InputPassword}
                  />
                </div>
              </div>
            </div>
            <div className='change-password__form__action'>
              <Button
                label={'Change Password'}
                type='submit'
                buttonType='success'
                isLoading={isSubmitting}
                onClick={handleSubmit}
              />
            </div>
          </div>
        </div>
        <div className='col-8 change-password__banner__col'>
          <div className='change-password__banner'>
            <img
              className='change-password__banner__img'
              src='/assets/images/change-password-cover-image.png'
              alt=''
            />
          </div>
        </div>
      </div>
    </div>
  );
});
